import {
  AIScanFoodOptionType,
  EdamamEntry,
  FoodType,
  MealType,
  NonIngredientsEntry,
} from "model/food/types"
import { INutrition } from "model/food/types/base.types"

export const getGram = (percent: number, gram?: null | number) => {
  return gram != null ? gram * percent : null
}

export const getNutrition = <T extends INutrition>(
  food: T,
  percent: number,
): INutrition => {
  const calorie = food.calorie * percent
  const fat = food.fat * percent
  const protein = food.protein * percent
  const carbohydrate = food.carbohydrate * percent
  const gram = getGram(percent, food.gram)

  return { calorie, fat, protein, carbohydrate, gram }
}

export const updateEdamaNutritionWhenUnitChange = (
  food: EdamamEntry,
  unitLabel: string,
): INutrition => {
  const currentUnit = food.units.find((unit) => unit.label === food.unit)
  const nextUnit = food.units.find((unit) => unit.label === unitLabel)

  if (!nextUnit || !currentUnit) {
    return {
      calorie: food.calorie,
      fat: food.fat,
      protein: food.protein,
      carbohydrate: food.carbohydrate,
      gram: food.gram,
    }
  }

  const percent = nextUnit.weight / currentUnit.weight

  return getNutrition(food, percent)
}

export const updateNonIngredientEntryNutritionWhenPortionChange = (
  entry: NonIngredientsEntry,
  portion: number,
) => {
  if (entry.portion === 0) {
    // Avoid divide-by-zero or NaN
    return getNutrition(entry, 0)
  }

  const percent = portion / entry.portion
  return getNutrition(entry, percent)
}

export const updateManualNutritionMealWhenPortionChange = (
  meal: MealType | FoodType | AIScanFoodOptionType,
  portion: number,
) => {
  if (meal.portion === 0) {
    // Avoid divide-by-zero or NaN
    return getNutrition(meal, 0)
  }

  const percent = portion / meal.portion
  return getNutrition(meal, percent)
}
